/* eslint-disable no-console */
import { call, put, takeLatest } from 'redux-saga/effects';
import { actions } from '../redux/Slices/BrazeSubscriptionSlice';
import invokeApi from '../network/index';
import networkConfig from '../network/config';
import { setErrorCode } from '../redux/Actions/ErrorAction';
import { StatusCodes } from 'http-status-codes';
const isOK = (status) => status === StatusCodes.OK || status === StatusCodes.CREATED || status === StatusCodes.ACCEPTED;
export function* checkHttpErrors(status, response) {
    if (!isOK(status)) {
        yield put(setErrorCode(status));
        // return false;
        throw new Error(response.message);
    }
    // return true;
}
export function* fetchBrazeSubscriptions(action) {
    try {
        const { payload: postData } = action;
        const { response, status } = yield call(invokeApi, networkConfig.brazeSubscriptions, null, null, postData);
        yield* checkHttpErrors(status, response);
        yield put(actions.fetchSuccess(response));
    }
    catch (error) {
        console.log('Failed to fetch content', error);
        yield put(actions.fetchFailed(error.message));
    }
}
export function* brazeSubscriptionsSaga() {
    yield takeLatest(actions.fetch.type, fetchBrazeSubscriptions);
}
